import fetchAPI from "../../../../../lib/utils/fetch-api";


interface ICompleteTask {
    id?: number;
    complete_reason?: string
}

export const completeTask = async (formData: ICompleteTask) => {
    try {
        const response = await fetchAPI(
            `/api/v2/task/complete`,
            {
                method: 'POST',
                body: JSON.stringify(formData)
            }
        )
        if (response['errors']) {
            let error = response['errors'];
            if (Array.isArray(error)) {
                error = error.join();
            }
            throw new Error(error);
        }

        return response;
    } catch (err) {
        console.log(err);
        return false;
    }
}
